import { CollapsibleContext } from "./chunk-P4FH6SY6.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Collapsible/Collapsible.Button.tsx
import React, { useCallback, useContext } from "react";
import clsx from "clsx";
import { Disclosure } from "@headlessui/react";
var CollapsibleButton = _a => {
  var _b = _a,
    {
      children,
      className,
      onKeyDown,
      onClick
    } = _b,
    rest = __objRest(_b, ["children", "className", "onKeyDown", "onClick"]);
  const {
    isOpen,
    id
  } = useContext(CollapsibleContext);
  const handleKeyDown = useCallback(event => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    if (typeof isOpen === "boolean" && (event.key === " " || event.key === "Enter")) {
      onClick == null ? void 0 : onClick();
    }
  }, [isOpen, onKeyDown, onClick]);
  return /* @__PURE__ */React.createElement(Disclosure.Button, __spreadProps(__spreadValues({}, rest), {
    "aria-describedby": "".concat(id, "-subtitle"),
    onKeyDown: handleKeyDown,
    onClick,
    className: clsx("pd-collapsible__button", className)
  }), children);
};
var Collapsible_Button_default = CollapsibleButton;
export { Collapsible_Button_default };